<template>
  <div>
    <el-table
      v-loading="listLoading"
      :data="tableLists"
      element-loading-text="Loading..."
      :empty-text="emptyText"
      border
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <slot />
    </el-table>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination v-if="showPage" layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fetchTableData" />
    </div>
    <!-- <pagination v-if="showPage" layout="total, prev, pager, next, jumper" :total="listQuery.total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="fetchTableData" /> -->
  </div>
</template>

<script>

// import Pagination from '@/components/Pagination'
import tableMix from './table.js'

export default {
  name: 'WqTable',
  // components: {
  //   Pagination
  // },
  mixins: [tableMix],
  data() {
    return {

    }
  },
  created() {
    this.fnInitData()
    this.fetchTableData()
  },
  methods: {

  }
}
</script>

<style scoped></style>
